import Experience from '../Experience'

export default class Events {
  constructor() {
    //setup
    this.experience = new Experience()
    this.camera = this.experience.camera
    this.scene = this.experience.scene
    this.world = this.experience.world

    //method
    this.setAnimation()
  }

  setAnimation() {}
}
